"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import UserSettingsBackground from "@/components/user/settings/UserSettingsBackground";
import UserSettingsSave from "@/components/user/settings/UserSettingsSave";
import { ApiCreateOrUpdateProfileRequest } from "@/entities/IProfile";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
export default function UserPageHeaderEditBanner(t0) {
  const $ = _c(47);
  const {
    profile,
    defaultBanner1,
    defaultBanner2,
    onClose
  } = t0;
  const modalRef = useRef(null);
  useClickAway(modalRef, onClose);
  useKeyPressEvent("Escape", onClose);
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    onProfileEdit
  } = useContext(ReactQueryWrapperContext);
  const [bgColor1, setBgColor1] = useState(profile?.banner1 ?? defaultBanner1);
  const [bgColor2, setBgColor2] = useState(profile?.banner2 ?? defaultBanner2);
  const [mutating, setMutating] = useState(false);
  const [haveChanges, setHaveChanges] = useState(false);
  let t1;
  if ($[0] !== bgColor1 || $[1] !== bgColor2 || $[2] !== profile.banner1 || $[3] !== profile.banner2) {
    t1 = () => {
      setHaveChanges(bgColor1 !== profile?.banner1 || bgColor2 !== profile?.banner2);
    };
    $[0] = bgColor1;
    $[1] = bgColor2;
    $[2] = profile.banner1;
    $[3] = profile.banner2;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== bgColor1 || $[6] !== bgColor2 || $[7] !== profile) {
    t2 = [profile, bgColor1, bgColor2];
    $[5] = bgColor1;
    $[6] = bgColor2;
    $[7] = profile;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async body => {
      setMutating(true);
      return await commonApiPost({
        endpoint: "profiles",
        body
      });
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onClose || $[11] !== onProfileEdit || $[12] !== setToast) {
    t4 = updatedProfile => {
      setToast({
        message: "Profile updated.",
        type: "success"
      });
      onProfileEdit({
        profile: updatedProfile,
        previousProfile: null
      });
      onClose();
    };
    $[10] = onClose;
    $[11] = onProfileEdit;
    $[12] = setToast;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== setToast) {
    t5 = error => {
      setToast({
        message: error as string,
        type: "error"
      });
    };
    $[14] = setToast;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setMutating(false);
    };
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t5) {
    t7 = {
      mutationFn: t3,
      onSuccess: t4,
      onError: t5,
      onSettled: t6
    };
    $[17] = t4;
    $[18] = t5;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const updateUser = useMutation(t7);
  let t8;
  if ($[20] !== bgColor1 || $[21] !== bgColor2 || $[22] !== profile.classification || $[23] !== profile.handle || $[24] !== profile.pfp || $[25] !== profile.primary_wallet || $[26] !== requestAuth || $[27] !== setToast || $[28] !== updateUser) {
    t8 = async e => {
      if (!profile.handle) {
        return;
      }
      e.preventDefault();
      if (!profile.primary_wallet || !profile.classification) {
        return;
      }
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          message: "You must be logged in to save settings",
          type: "error"
        });
        return;
      }
      const body_0 = {
        handle: profile.handle,
        classification: profile.classification,
        banner_1: bgColor1,
        banner_2: bgColor2
      };
      if (profile.pfp) {
        body_0.pfp_url = profile.pfp;
      }
      await updateUser.mutateAsync(body_0);
    };
    $[20] = bgColor1;
    $[21] = bgColor2;
    $[22] = profile.classification;
    $[23] = profile.handle;
    $[24] = profile.pfp;
    $[25] = profile.primary_wallet;
    $[26] = requestAuth;
    $[27] = setToast;
    $[28] = updateUser;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  const onSubmit = t8;
  if (typeof document === "undefined") {
    return null;
  }
  let t9;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      inset: 0,
      position: "fixed",
      zIndex: 1100
    };
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== onClose) {
    t10 = <button type="button" aria-label="Close edit banner modal" className="tw-absolute tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-cursor-pointer tw-border-none tw-p-0" onClick={onClose} />;
    $[31] = onClose;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <h2 id="user-page-header-edit-banner-title" className="tw-sr-only">Edit Banner</h2>;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== bgColor1 || $[35] !== bgColor2) {
    t12 = <UserSettingsBackground bgColor1={bgColor1} bgColor2={bgColor2} setBgColor1={setBgColor1} setBgColor2={setBgColor2} />;
    $[34] = bgColor1;
    $[35] = bgColor2;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  const t13 = !haveChanges;
  let t14;
  if ($[37] !== mutating || $[38] !== t13) {
    t14 = <UserSettingsSave loading={mutating} disabled={t13} />;
    $[37] = mutating;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== onSubmit || $[41] !== t12 || $[42] !== t14) {
    t15 = <div className="tw-relative tw-flex tw-min-h-full tw-w-full tw-overflow-y-auto tw-items-center tw-justify-center tw-p-2 lg:tw-p-4"><div ref={modalRef} className="tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 tw-p-6 lg:tw-p-8 sm:tw-max-w-3xl md:tw-max-w-2xl">{t11}<form onSubmit={onSubmit} className="tw-flex tw-flex-col tw-gap-y-6">{t12}{t14}</form></div></div>;
    $[40] = onSubmit;
    $[41] = t12;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t10 || $[45] !== t15) {
    t16 = createPortal(<dialog open={true} aria-modal="true" aria-labelledby="user-page-header-edit-banner-title" className="tailwind-scope tw-m-0 tw-p-0 tw-border-0 tw-bg-transparent tw-w-screen tw-h-[100dvh] tw-cursor-default" style={t9}>{t10}{t15}</dialog>, document.body);
    $[44] = t10;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  return t16;
}